import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppInput from "../../../components/AppInput";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import SelectInput from "../../../components/SelectInput";
import { Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { ErrorToast } from "../../../widgets/AppToast";
import useDocumentUpload from "../../../hooks/useDocumentUpload";
import TextArea from "antd/es/input/TextArea";

function ViewOilRecordLog() {
  const { oil_record_id } = useParams();
  const [errors, set_errors] = useState({});
  const [code, set_code] = useState("");
  const [date, set_date] = useState("");
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [initialDocument, setInitialDocument] = useState([]);
  const { documentList, handleDocumentChange } =
    useDocumentUpload(initialDocument);

  const groupedOptions = codeItemList.flatMap((item) => {
    if (item.sub_code_name.length > 0) {
      return {
        label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
        options: item.sub_code_name.map((sub, index) => ({
          value: `${item.value}-${index}`,
          label: ` ${sub?.subdetails_child}`,
        })),
      };
    } else {
      return {
        value: item.value,
        label: item.label,
      };
    }
  });

  const LIST_OIL_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("orb_part", "1");
      post(ApiURL.list_code_categories_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRespones = res?.code_categories?.map((item) => {
            return {
              value: item?.id,
              label: `(${item?.value}) ` + item?.label,
            };
          });
          setCodeList(newRespones);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_OIL_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code_category_id", code_id);
      FORM_DATA.append("orb_part", "1");
      post(ApiURL.list_subdetails_category_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.subdetails?.map((item) => {
            return {
              value: item?.id,
              label: item?.sub_code_name,
              sub_code_name: item?.subdetails_child,
            };
          });
          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const VIEW_OIL_RECORD_LOGBOOK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", atob(oil_record_id));
    FORM_DATA.append("orb_part", "1");
    post(ApiURL.company_single_orb_record, FORM_DATA).then((res) => {
      if (res?.status == true) {
        const oilRecordData = res?.data;
        set_code(oilRecordData?.code_category);
        LIST_OIL_RECORD_CODE_API();
        LIST_OIL_RECORD_ITEM_API(oilRecordData?.code_category);
        const subDetailValues = oilRecordData?.sub_detail_values;
        setSelectedItems(
          Array.isArray(subDetailValues)
            ? subDetailValues
            : typeof subDetailValues === "string" &&
              subDetailValues.trim() !== ""
            ? JSON.parse(subDetailValues)
            : []
        );
        set_date(oilRecordData?.date);
        set_signature(oilRecordData?.operation_details);
        setInitialDocument(oilRecordData?.files);
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    });
  };

  useEffect(() => {
    VIEW_OIL_RECORD_LOGBOOK_APIS();
  }, []);

  const getDocUrl = (file) => {
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      ErrorToast("Error mesaage", "No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="white-container">
        <br />
        <h3>Oil Record book Part 1 Information </h3>
        <br />
        <div className="row">
          <div className="col-6">
            <SelectInput
              disabled={true}
              label="Code"
              value={code}
              placeholder=" -- Selecte Code  -- "
              style={{ width: "100%" }}
              onChange={(value) => {
                set_code(value);
                setSelectedItems([]);
              }}
              options={codeList}
              errors={errors?.code}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={true}
              type="date"
              label="Date"
              placeholder="Date"
              value={date}
              onChange={(e) => set_date(e.target.value)}
              errors={errors.date}
            />
          </div>
        </div>
        {code && (
          <div
            className="col-12"
            style={{
              lineHeight: "2",
              border: "1px solid #d9d9d9",
              borderRadius: "10px",
            }}
          >
            <strong className="form-label">Select Items:</strong>
            {groupedOptions.map((optionGroup, index) => (
              <div key={index} className="mb-3">
                {/* Main Label as Checkbox */}
                <div className="row align-items-center mb-2">
                  <div className="col-6">
                    <div className="form-check">
                      {optionGroup?.options?.length > 1 ? (
                        ""
                      ) : (
                        <input
                          // disabled={true}
                          className="form-check-input"
                          type="checkbox"
                          value={optionGroup.label}
                          checked={selectedItems.some(
                            (item) => item.id === optionGroup.value
                          )}
                          id={`group-checkbox-${index}`}
                        />
                      )}
                      <label
                        className="form-check-label"
                        htmlFor={`group-checkbox-${index}`}
                      >
                        {typeof optionGroup.label === "string" ? (
                          <strong>{optionGroup.label}</strong>
                        ) : (
                          <strong>{optionGroup.label.props.children}</strong>
                        )}
                      </label>
                    </div>
                  </div>

                  {/* Input Field for Main Label */}
                  <div className="col-6" style={{ marginLeft: "22px" }}>
                    {selectedItems.some(
                      (item) => item.id === optionGroup.value
                    ) && (
                      <TextArea
                        required
                        maxLength={1000}
                        className="form-control"
                        autoSize={{ minRows: 2 }}
                        placeholder={
                          typeof optionGroup.label === "string"
                            ? optionGroup.label
                            : optionGroup.label.props.children
                        }
                        value={
                          selectedItems.find(
                            (item) => item.id === optionGroup.value
                          )?.value || ""
                        }
                      />
                    )}
                  </div>
                  {/* Special Input - Only for 112 */}
                  {/* {Number(optionGroup.value) === 112 && (
                    <div className="col-6" style={{ marginBottom: 20 }}>
                      {selectedItems.some(
                        (item) => Number(item.id) === 112
                      ) && (
                        <TextArea
                          required
                          maxLength={1000}
                          className="form-control"
                          autoSize={{ minRows: 2 }}
                          placeholder="Discharged Volume"
                          value={
                            selectedItems.find(
                              (item) => Number(item.id) === 112
                            )?.dischargedvolume || ""
                          }
                        />
                      )}
                    </div>
                  )} */}
                </div>

                {/* Sub-options */}
                {optionGroup.options && (
                  <div
                    className="ms-3"
                    style={{ marginLeft: "30px", padding: "10px" }}
                  >
                    {optionGroup.options.map((option) => (
                      <div
                        key={option.value}
                        className="row align-items-center mb-2"
                      >
                        {/* Left Side - Checkbox */}
                        <div className="col-6">
                          <div className="form-check">
                            <input
                              disabled={true}
                              className="form-check-input"
                              type="checkbox"
                              value={option.value}
                              checked={selectedItems.some(
                                (item) => item.id === option.value
                              )}
                              id={`checkbox-${option.value}`}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`checkbox-${option.value}`}
                            >
                              {option.label}
                            </label>
                          </div>
                        </div>

                        {/* Right Side - Input Field */}
                        {/* <div className="col-6" style={{ padding: "5px" }}>
                          {selectedItems.some(
                            (item) => item.id === option.value
                          ) && (
                            <TextArea
                              required
                              maxLength={1000}
                              className="form-control"
                              autoSize={{ minRows: 2 }}
                              placeholder={option.label}
                              value={
                                selectedItems.find(
                                  (item) => item.id === option.value
                                )?.value || ""
                              }
                            />
                          )}
                        </div> */}
                        {/* Special case: two inputs only for id '111-3' and code '24' */}
                        {option.value === "111-3" && (
                          <div className="col-6" style={{ padding: "5px" }}>
                            {selectedItems.some(
                              (item) => item.id === option.value
                            ) && (
                              <TextArea
                                required
                                maxLength={1000}
                                className="form-control"
                                autoSize={{ minRows: 2 }}
                                placeholder={"Evaporation Volume"}
                                value={
                                  selectedItems.find(
                                    (item) => item.id === option.value
                                  )?.evaporationVolume || "" // <- new JSON key
                                }
                              />
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="row" style={{ paddingTop: "10px" }}>
          <div className="col-6">
            <AppInput
              disabled={true}
              label="Name of operation incharge"
              placeholder="Name of operation incharge"
              value={signature}
              onChange={(e) => set_signature(e.target.value)}
              errors={errors.signature}
            />
          </div>
          <div className="col-6">
            <div
              className="input-box"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              <label>Select File</label>
              <Upload
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                multiple
                fileList={documentList}
                onChange={handleDocumentChange}
                onPreview={handlePreviews}
                beforeUpload={() => false}
                listType="picture"
                disabled
              >
                <Button
                  disabled
                  icon={<UploadOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                    width: "40px",
                    height: "40px",
                    marginLeft: "10px",
                  }}
                ></Button>
              </Upload>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewOilRecordLog;
